/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Event_Deal_Stage_ChangedInputs */

const cs_automation_event_deal_stage_changed = /** @type {(inputs: Automation_Event_Deal_Stage_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna fáze obchodu`)
};

const en_automation_event_deal_stage_changed = /** @type {(inputs: Automation_Event_Deal_Stage_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal stage changed`)
};

/**
* | output |
* | --- |
* | "Deal stage changed" |
*
* @param {Automation_Event_Deal_Stage_ChangedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_event_deal_stage_changed = /** @type {((inputs?: Automation_Event_Deal_Stage_ChangedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Event_Deal_Stage_ChangedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_event_deal_stage_changed(inputs)
	return cs_automation_event_deal_stage_changed(inputs)
});